import { lazy, Suspense } from 'react';
import { useResponsiveComponent } from '@/hooks/useResponsiveComponent';

// Lazy load mobile and desktop components
const NoticesPage = lazy(() => import('./buyer/NoticesPage').then(module => ({ default: module.NoticesPage })));
const DesktopNoticesPage = lazy(() => import('./desktop/DesktopNoticesPage').then(module => ({ default: module.DesktopNoticesPage })));

// Loading component for suspense fallback
function NoticesPageLoader() {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <div className="w-8 h-8 border-4 border-gray-200 border-t-[#86DB89] rounded-full animate-spin"></div>
        <p className="text-[#666666] text-base">공지사항 페이지를 불러오는 중...</p>
      </div>
    </div>
  );
}

/**
 * Responsive wrapper that automatically switches between mobile and desktop
 * versions of the Notices page based on screen size (1024px breakpoint)
 */
export function ResponsiveNoticesPage() {
  const isDesktop = useResponsiveComponent(1024);

  return (
    <Suspense fallback={<NoticesPageLoader />}>
      {isDesktop ? <DesktopNoticesPage /> : <NoticesPage />}
    </Suspense>
  );
}